import { Typography } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'

function SpecialEntityRoute() {
	return <Typography>Special route for this entity.</Typography>
}

export const Route = createFileRoute('/_authenticated/$entity/special')({
	component: SpecialEntityRoute,
})
